import {type ParserT, Parser, string} from '@freckle/parser'

export type RlStandardIdT = string

export const parse: ParserT<RlStandardIdT> = Parser.map(
  string(),
  'RlStandardIdT.fromString',
  fromString
)

function fromString(rlStandardId: string): RlStandardIdT {
  return rlStandardId
}
